export const method = {

  POST: 'post',
  GET: 'get',
  DELETE: 'delete',
  PUT: 'put',

}
